// src/data/ServicesList.js (example shape)
export const services = [
  {
    id: "always-on-seo",
    slug: "always-on-seo",
    title: "Always-On SEO & Content System",
  },
  {
    id: "growth-blueprint",
    slug: "growth-blueprint",
    title: "Growth Blueprint & Tracking Setup",
  },
  {
    id: "acquisition-sprints",
    slug: "acquisition-sprints",
    title: "Paid Acquisition Sprints",
  },
  {
    id: "site-funnels",
    slug: "site-funnels",
    title: "Website & funnels",
  },
  {
    id: "retention-crm",
    slug: "retention-crm",
    title: "Email, CRM & Lifecycle Automation",
  },
  {
    id: "embedded-pod",
    slug: "embedded-pod",
    title: "Embedded Growth Pod",
  },
];
